/* eslint-disable no-extend-native */
// eslint-disable-next-line no-restricted-globals
String.prototype.camelize = function camelize(str: string): string {
  // lowercase all characters and trim duplicate whitespaces before start
  str = str.toLowerCase().replace(/\s+/g, " ").trim();
  str = str
    .replace(
      /\w+/g, // match all words
      (txt) =>
        // uppercase first letter and add rest unchanged
        txt.charAt(0).toUpperCase() + txt.substr(1)
    )
    .replace(/\s/g, ""); // remove remaining spaces

  return str;
};
